<div class="zwi-icon-container">
  <a href="https://www.zwiloo.com" target="_blank">
    <img src="assets/icon.png" class="zwi-icon">
  </a>
</div>
